// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "0.3.20/static/js/" + chunkId + "." + "0c558843" + ".chunk.js";
};